var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detour)?_c('div',[_c('General',{on:{"detour":function($event){return _vm.ecranDetourage()}}})],1):_c('div',[_c('Detourage',{on:{"finPopUp":function($event){return _vm.ecranSuivant()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }